import { createContext, useContext } from 'react';

import { AspirationsToday } from '@/types.gql';

const OpuSearchContext = createContext<{
  selectedAspiration: AspirationsToday | undefined;
  setSelectedAspiration: React.Dispatch<
    React.SetStateAction<AspirationsToday | undefined>
  >;
  qcDataSubmitted: boolean;
  setQcDataSubmitted: React.Dispatch<React.SetStateAction<boolean>>;
} | null>(null);

// eslint-disable-next-line react-refresh/only-export-components
export function useOpuSearchContext() {
  const context = useContext(OpuSearchContext);

  if (!context) {
    throw new Error(
      'OpuSearch.* component must be rendered as child of OpuSearch component',
    );
  }

  return context;
}

export default OpuSearchContext;
